import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpUrlEncodingCodec, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { CryptoService } from './crypto.service';

class Base64Encoder extends HttpUrlEncodingCodec {
  encodeValue(value: string): string {
    return encodeURIComponent(value);
  }
}

@Injectable()
export class CryptoInterceptor implements HttpInterceptor {
  // endpoints que no se cifran ni llevan token
  private readonly EXCLUDED = [
    '/usuarios/cerrar-sesion',
    '/usuarios/job'
  ];

  // endpoints que cifran params pero no llevan header (timestamp va dentro de data)
  private readonly LOGIN_PATHS = [
    '/usuarios/login',
    '/usuarios/recuperar'
  ];

  constructor(private crypto: CryptoService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // excluidos: pasan sin cambios
    if (this.isExcluded(req.url)) {
      return next.handle(req);
    }

    // login / recuperar: cifrar params con timestamp dentro de data
    if (this.isLoginPath(req.url)) {
      return next.handle(this.handleLogin(req));
    }

    console.log('isRegisterPost', this.isRegisterPost(req));

    // POST /usuarios (registrar): timestamp en data, body intacto
    if (this.isRegisterPost(req)) {
      return next.handle(this.handleRegister(req));
    }

    // multipart: solo agregar header X-Request-Token, params van normal
    if (req.body instanceof FormData) {
      const cloned = req.clone({
        setHeaders: { 'X-Request-Token': this.crypto.encryptTimestamp() }
      });
      return next.handle(cloned);
    }

    // request normal: cifrar params + agregar header
    return next.handle(this.handleNormal(req));
  }

  // método reutilizable para construir HttpParams con encoding correcto
  private buildEncryptedParams(encrypted: string): HttpParams {
    return new HttpParams({ encoder: new Base64Encoder() })
      .set('data', encrypted);
  }

  private handleLogin(req: HttpRequest<any>): HttpRequest<any> {
    // NOTA: ya NO se envía el header Authorization: Basic
    let queryString = '';
    req.params.keys().forEach((key, index) => {
      if (index > 0) queryString += '&';
      queryString += encodeURIComponent(key) + '=' + encodeURIComponent(req.params.get(key));
    });

    // se agrega timestamp (hora local, sin desfase porque aún no hay serverTime)
    queryString += '&timestamp=' + Date.now();
    
    // se cifra todo y se codifica
    const encrypted = this.crypto.encrypt(queryString);

    return req.clone({ params: this.buildEncryptedParams(encrypted) });
  }

  handleRegister(req: HttpRequest<any>): HttpRequest<any> {
    let queryString = '';
    req.params.keys().forEach((key, index) => {
      if (index > 0) queryString += '&';
      queryString += encodeURIComponent(key) + '=' + encodeURIComponent(req.params.get(key));
    });

    if (queryString.length > 0) queryString += '&';
    queryString += 'timestamp=' + Date.now();

    console.log('qryString handleRegister', queryString);

    // se cifra todo y se codifica
    const encrypted = this.crypto.encrypt(queryString);

    return req.clone({ 
      params: this.buildEncryptedParams(encrypted), 
      setHeaders: { 'X-Request-Token': this.crypto.encryptTimestamp() } 
    });
  }

  private handleNormal(req: HttpRequest<any>): HttpRequest<any> {
    // se cifran params si hay
    let clonedReq = req;

    if (req.params.keys().length > 0) {
      let queryString = '';
      req.params.keys().forEach((key, index) => {
        if (index > 0) queryString += '&';
        queryString += encodeURIComponent(key) + '=' + encodeURIComponent(req.params.get(key));
      });

      console.log('queryString', queryString);
      
      const encrypted = this.crypto.encrypt(queryString);

      clonedReq = req.clone({ params: this.buildEncryptedParams(encrypted) });
    }

    // se agrega header con timestamp cifrado
    return clonedReq.clone({
      setHeaders: { 'X-Request-Token': this.crypto.encryptTimestamp() }
    });
  }

  private isExcluded(url: string): boolean {
    return this.EXCLUDED.some(path => url.includes(path));
  }

  private isLoginPath(url: string): boolean {
    return this.LOGIN_PATHS.some(path => url.includes(path));
  }

  private isRegisterPost(req: HttpRequest<any>): boolean {

    if (req.method !== 'POST') return false;

    // POST /usuarios (sin subpath como /nuevo)
    return req.url.match(/\/usuarios(\/.*)?$/) !== null;
  }

}


// WEBPACK FOOTER //
// ./src/app/security/crypto.interceptor.ts